import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IUserWithPublicInfo } from '../types/IUser';

export interface IGetUsersParams extends IGetItemsParams {
  getItemCounts?: boolean;
}

export interface IGetUsersResult extends IGetItemsResult {
  users: IUserWithPublicInfo[];
}

export class GetUsersRequest extends Request<IGetUsersParams, IGetUsersResult> {
  constructor(params: IGetUsersParams) {
    super('getUsers', params);
  }
}
